<div class="h-auto flex flex-col gap-2 mx-1">
    <app-source-header
        [areLayersGrouped]="areLayersGrouped()"
        [disabledSourcesCount]="disabledSourcesCount()"
        (handleLayersVisibility)="handleLayersVisibility($event)"
        (updateLayerGrouped)="updateLayersGrouped($event)" />

    @if (layerSourcesByTheme().length || sourcesWithoutTheme().length) {
        <app-expansion-panel
            class="mx-2 overflow-hidden"
            [isExpanded]="true">
            <span
                class="text-headline-6 font-medium"
                header>
                {{ 'mapData' | transloco }}
            </span>
            <div
                class="flex flex-col"
                content>
                @for (entry of layerSourcesByTheme(); track entry.theme.id) {
                    <div class="mb-2">
                        <app-source-theme
                            [areLayersGrouped]="areLayersGrouped()"
                            [groupedSources]="entry.groups"
                            [theme]="entry.theme" />
                    </div>
                }

                @for (source of sourcesWithoutTheme(); track source) {
                    <div class="mb-2">
                        <app-source-item
                            [depositName]="areLayersGrouped() ? null : source[0].depositName"
                            [hasTabView]="true"
                            [isDataLayerSource]="true"
                            [isFiltered]="source[0].isFiltered"
                            [layerEditConfigInput]="layerEditConfigForLayerSources()"
                            [sourceType]="SourceTypeEnum.LAYER_SOURCE"
                            [sources]="source"
                            (openTabView)="openLayerInExternalWindow($event, source[0].name)" />
                    </div>
                }
            </div>
        </app-expansion-panel>
    }

    @if (interstandardSourcesByTheme().length || interstandardWithoutTheme().length) {
        <app-expansion-panel
            class="mx-2 overflow-hidden"
            [isExpanded]="true">
            <span
                class="text-headline-6 font-medium"
                header>
                {{ 'interstandard' | transloco }}
            </span>
            <div
                class="flex flex-col"
                content>
                @for (entry of interstandardSourcesByTheme(); track entry.theme.id) {
                    <div class="mb-2">
                        <app-source-theme
                            [areLayersGrouped]="areLayersGrouped()"
                            [canBeEdited]="false"
                            [groupedSources]="entry.groups"
                            [hasTabView]="false"
                            [theme]="entry.theme" />
                    </div>
                }

                @for (source of interstandardWithoutTheme(); track source.sourceId) {
                    <div class="mb-2">
                        <app-source-item
                            [canBeEdited]="false"
                            [depositName]="areLayersGrouped() ? null : source.depositName"
                            [hasTabView]="false"
                            [isDataLayerSource]="true"
                            [isFiltered]="!!source.isFiltered"
                            [sourceType]="SourceTypeEnum.LAYER_SOURCE"
                            [sources]="[source]" />
                    </div>
                }
            </div>
        </app-expansion-panel>
    }

    @if (urlLayerSources().length) {
        <app-expansion-panel
            class="mx-2 overflow-hidden"
            [isExpanded]="true">
            <span
                class="text-headline-6 font-medium"
                header>
                {{ 'httpFlow' | transloco }}
            </span>

            <div
                class="flex flex-col grow"
                content>
                @for (source of urlLayerSources(); track source.sourceId) {
                    <div class="mb-2">
                        <app-source-item
                            [sourceType]="SourceTypeEnum.URL_LAYER_SOURCE"
                            [sources]="[source]"
                            [wmsUrl]="source.data.type === Layer.TypeEnum.WMS ? source.data.url : null" />
                    </div>
                }
            </div>
        </app-expansion-panel>
    }

    @if (fieldInterventionSources().length) {
        <app-expansion-panel
            class="mx-2 overflow-hidden"
            [isExpanded]="true">
            <span
                class="text-headline-6 font-medium"
                header>
                {{ 'fieldIntervention' | transloco }}
            </span>

            <div
                class="flex flex-col"
                content>
                @for (source of fieldInterventionSources(); track source.sourceId) {
                    <div class="mb-2">
                        <app-source-item
                            [disabled]="isFieldInterventionDisabled(source)"
                            [sourceType]="SourceTypeEnum.FIELD_INTERVENTION"
                            [sources]="[source]" />
                    </div>
                }
            </div>
        </app-expansion-panel>
    }

    @if (noGeomLayers().length) {
        <app-expansion-panel
            class="mx-2 overflow-hidden"
            [isExpanded]="true">
            <span
                class="text-headline-6 font-medium"
                header>
                {{ 'tabularData' | transloco }}
            </span>
            <div
                class="flex flex-col"
                content>
                @for (noGeomLayer of noGeomLayersGroupedSource(); track noGeomLayer.name) {
                    <div
                        class="group mb-2 bg-on-primary p-2 rounded-xl flex flex-row items-center flex-1 truncate text-lg font-normal leading-tight">
                        <span class="flex flex-row justify-between items-center w-full cursor-pointer py-3">
                            {{ noGeomLayer.name }}
                        </span>
                        <div class="flex items-center gap-3 shrink-0 pr-4">
                            @if (tabularLayerEditConfig()?.showAddEntity) {
                                <div class="w-5 h-5 text-base items-center justify-center">
                                    <app-add-entity-button
                                        [customTooltipKey]="
                                            !projectEditModeService.editableLayerIds().includes(noGeomLayer.id)
                                                ? ('editMode.layerStandardNotEditable' | transloco)
                                                : ''
                                        "
                                        [hasPermission]="!!tabularLayerEditConfig()?.canAddEntity"
                                        [isActive]="
                                            mapEditModeService.activeEditLayerIds().has(noGeomLayer.id) &&
                                            mapEditModeService.isAddEntityModeActive()
                                        "
                                        [isAvailable]="
                                            projectEditModeService.editableLayerIds().includes(noGeomLayer.id)
                                        "
                                        [layerEditConfig]="tabularLayerEditConfig()"
                                        (click)="handleAddEntity(noGeomLayer.id, noGeomLayer.name)" />
                                </div>
                            }
                            <fa-icon
                                class="w-5 h-5 text-base hover:text-custom-blue cursor-pointer text-black"
                                [icon]="['far', 'table-list']"
                                (click)="openLayerInExternalWindow($event, noGeomLayer.name)" />
                        </div>
                    </div>
                }
            </div>
        </app-expansion-panel>
    }

    <div class="bg-background-v2 flex flex-col grow h-full"></div>
</div>
